module.exports = __webpack_public_path__ + "static/media/mage-card.625ce6aa.png";